import { connect } from 'react-redux';
import CheckoutBlock from './checkout-block';
import { checkoutBlockSelector } from './connect/checkout-block.selector';
import { checkoutBlockDispatcher } from './connect/checkout-block.dispatcher';
export default connect(checkoutBlockSelector, checkoutBlockDispatcher)(CheckoutBlock);